import { createFeatureSelector, createSelector } from '@ngrx/store';
import { EscalationState, featureKey, State } from './escalation.combiner';

export const selectEscalationState = createFeatureSelector<EscalationState, State>(featureKey);
export const selectEscalationCategoryState = createSelector(selectEscalationState, (state: State) => state.escalationCategory);
export const selectEscalationUiState = createSelector(selectEscalationState, (state: State) => state.ui);
